const OrderProcessActionType = {
  SUBMITTING_FORM: 'SUBMITTING_FORM',
  RECEIVE_FORM_SUBMISSION_RESPONSE: 'RECEIVE_FORM_SUBMISSION_RESPONSE',
  RESET_ELIGIBILITY: 'RESET_ELIGIBILITY',
  VALIDATE_EMAIL: 'VALIDATE_EMAIL',
  RECEIVE_EMAIL_VALIDATION_RESPONSE: 'RECEIVE_EMAIL_VALIDATION_RESPONSE',
};

export default OrderProcessActionType;
